import React from 'react'
import PropTypes from 'prop-types'
import userImage from '../../../resources/images/user.svg'
import { polyglot } from '../../../index'
// import { PanelWithNoDataSupport } from '../../common/PanelWithNoDataSupport'
import { getAgeDescription, getFormattedBirthDate } from '../../../resources/utilities'
// import { StaticInformations } from '../../common/StaticInformations'

export default class PatientBox extends React.Component {
  handlePatientName (name) {
    const arr = name.split(' ')
    let shortenedName = ''
    if (arr.length > 2) {
      arr.forEach((name, index) => {
        if (index === 0) {
          shortenedName = shortenedName.concat(name).concat(' ')
        } else if (index === arr.length - 1) {
          shortenedName = shortenedName.concat(name)
        } else {
          shortenedName = shortenedName.concat(`${name.charAt(0)}.`).concat(' ')
        }
      })
    } else {
      return name
    }
    return shortenedName
  }
  render () {
    return (
      <div>
        <div className='thumbnail patient-photo'>
          <img onClick={this.toggleModal}
            src={this.props.patient['photo'] ? this.props.patient['photo'] : userImage} alt={polyglot.t('staticFields.patientBox.patientPhoto')} />
          <div className='caption patient-info'>
            <h3>{this.handlePatientName(this.props.patient.name)}</h3>
            {this.props.patient.birthDate
              ? <div>
                <h4>{getAgeDescription(this.props.patient['birthDate'])}</h4>
                <h5><span />{polyglot.t('staticFields.patientBox.birthday')} - {getFormattedBirthDate(this.props.patient['birthDate'])}</h5>
              </div>
              : null
            }
          </div>
        </div>
      </div>
    )
  }
}

PatientBox.propTypes = {
  patient: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/Home/PatientBox.js